import { InterestsWebScreenBody } from './interests-web-screen-body';
import type { InterestsScreenState } from './use-interests-screen';

/** Large UI: skip link left, primary actions right on the suggestions step. */
export function InterestsScreenBodyLarge(props: InterestsScreenState) {
  return <InterestsWebScreenBody layout="large" state={props} />;
}
